<app-breadcrumb [title]="'Editar'" [items]="['Vehiculos']" [active_item]="'Editar'"></app-breadcrumb>
<div class="col-sm-12 col-xl-12">
  <ngb-accordion [closeOthers]="true" [activeIds]="activePanel" #accordion="ngbAccordion">
    <ngb-panel id="static-1">
      <ng-template ngbPanelTitle>
        <i class="fa fa-car"></i>
        <span (click)="togglePanel('static-1')" class="ms-2 text-uppercase"><strong>Datos Básicos</strong></span>
      </ng-template>
      <ng-template ngbPanelContent>
        <div class="card">
          <div class="card-body">
            <form [formGroup]="formNuevo">
              <div class="row g-3 mb-3">
                <div class="col-md-3">
                  <label class="form-label" for="servicio"><strong>Tipo de Servicio *:</strong></label>
                  <select id="servicio" class="form-control" formControlName="servicio" #inputServicio required
                    [ngClass]="{
                  'is-invalid':
                    formNuevo.controls['servicio'].invalid &&
                    formNuevo.controls['servicio'].touched
                }" (change)="ValidarDocumentosPorId($event.target.value)">
                    <option value="" disabled>Selecciona una opción</option>
                    <option *ngFor="let opcion of tiposervicio" [value]="opcion.idServicio">
                      {{ opcion.Descripcion }}
                    </option>
                  </select>

                  <div *ngIf="
                    formNuevo.controls['servicio'].invalid &&
                    formNuevo.controls['servicio'].touched
                  " class="invalid-feedback">
                    {{ errores.servicio }}
                  </div>
                </div>

                <div class="col-md-3">
                  <label class="form-label" for="placa"><strong>Placa *:</strong></label>
                  <input #inputPlaca class="form-control" id="placa" type="text" placeholder="Ingrese la placa" required
                    formControlName="placa" maxlength="6" autocomplete="off" (input)="validarPlaca($event)" [ngClass]="{
                    'is-invalid':
                      formNuevo.controls['placa'].invalid &&
                      formNuevo.controls['placa'].touched
                  }" />

                  <div *ngIf="
                    formNuevo.controls['placa'].invalid &&
                    formNuevo.controls['placa'].touched
                  " class="invalid-feedback">
                    <span *ngIf="formNuevo.controls['placa'].errors?.required">La placa es obligatoria.</span>
                    <span *ngIf="formNuevo.controls['placa'].errors?.pattern">Debe contener exactamente 6 caracteres
                      alfanuméricos.</span>
                  </div>
                </div>

                <div class="col-md-3">
                  <label class="form-label" for="interno"><strong>Número Interno *:</strong></label>
                  <input #inputInterno class="form-control" id="interno" type="text"
                    placeholder="Ingrese un número interno" autocomplete="off" required formControlName="interno"
                    [ngClass]="{
                    'is-invalid':
                      formNuevo.controls['interno'].invalid &&
                      formNuevo.controls['interno'].touched
                  }" />
                  <div *ngIf="
                    formNuevo.controls['interno'].invalid &&
                    formNuevo.controls['interno'].touched
                  " class="invalid-feedback">
                    {{ errores.interno }}
                  </div>
                </div>

                <div class="col-md-3">
                  <label class="form-label" for="afiliacion"><strong>Fecha de Ingreso *:</strong></label>
                  <div class="input-group input-group-sm">
                    <input #inputAfiliacion id="afiliacion" type="date" class="form-control form-control-lg fs-14" name="afiliacion"
                      placeholder="dd/mm/aaaa" formControlName="afiliacion" [max]="maxDate" 
                      autocomplete="off"
                      (input)="onFechaAfiliacionChange($event)"
                      (blur)="formNuevo.get('afiliacion')?.markAsTouched()"
                      (change)="formNuevo.get('afiliacion')?.updateValueAndValidity()"
                      [ngClass]="{
                        'is-invalid': formNuevo.controls['afiliacion'].invalid && 
                                     formNuevo.controls['afiliacion'].touched
                      }" />
                  </div>
                  <div *ngIf="(formNuevo.controls['afiliacion'].invalid && 
                              formNuevo.controls['afiliacion'].touched) ||
                             (formNuevo.controls['afiliacion'].value && 
                              formNuevo.controls['afiliacion'].invalid)" 
                       class="invalid-feedback d-block">
                    <span *ngIf="formNuevo.controls['afiliacion'].errors?.required">
                      La fecha de afiliación es obligatoria.
                    </span>
                    <span *ngIf="formNuevo.controls['afiliacion'].errors?.fechaFutura">
                      La fecha no puede ser futura.
                    </span>
                    <span *ngIf="formNuevo.controls['afiliacion'].errors?.fechaMuyAntigua">
                      La fecha es muy antigua (mínimo: 01/01/1990).
                    </span>
                  </div>
                </div>
   <div class="col-md-3">
                  <label class="form-label"><strong>Clase *:</strong></label>
                  <div class="input-group">
                    <div class="form-control p-0 border-0">
                      <ng-select #inputClase id="clase" [items]="tipos" bindLabel="tipos" bindValue="idTipos"
                        placeholder="Selecciona una opción" formControlName="clase"
                        class="js-example-placeholder-multiple" style="flex-grow: 1" [class.is-invalid]="
                      formNuevo.get('clase')?.invalid &&
                      formNuevo.get('clase')?.touched
                    ">
                      </ng-select>
                    </div>
                    <button type="button" class="btn btn-primary btn-sm" (click)="openModalClase(myModal2)">
                      <i class="icofont icofont-plus"></i>
                    </button>
                  </div>
                  <div *ngIf="
                      formNuevo.get('clase')?.invalid &&
                      formNuevo.get('clase')?.touched
                    " class="invalid-feedback">
                    {{ errores.clase }}
                  </div>
                </div>

                <div class="col-md-3">
                  <label class="form-label" for="marca"><strong>Marca *:</strong></label>
                  <div class="input-group">
                    <ng-select #inputMarca id="marca" [items]="marcas" bindLabel="marca" bindValue="id"
                      formControlName="marca" style="flex-grow: 1" [class.is-invalid]="
                      formNuevo.get('marca')?.invalid &&
                      formNuevo.get('marca')?.touched
                    ">
                    </ng-select>
                  </div>

                  <div *ngIf="
                    formNuevo.get('marca')?.invalid &&
                    formNuevo.get('marca')?.touched
                  " class="invalid-feedback">
                    {{ errores.marca }}
                  </div>
                </div>

                <div class="col-md-3">
                  <label class="form-label" for="modelo"><strong>Modelo *:</strong></label>
                  <div class="input-group">
                    <ng-select #inputModelo id="modelo" [items]="modelos" bindLabel="modelo" bindValue="modelo"
                      placeholder="Selecciona una opción" class="js-example-placeholder-multiple" style="flex-grow: 1"
                      formControlName="modelo" [class.is-invalid]="
                      formNuevo.get('modelo')?.invalid &&
                      formNuevo.get('modelo')?.touched
                    ">
                    </ng-select>
                    <div *ngIf="
                      formNuevo.get('modelo')?.invalid &&
                      formNuevo.get('modelo')?.touched
                    " class="invalid-feedback">
                      {{ errores.modelo }}
                    </div>
                  </div>
                </div>
                <div class="col-md-3">
                  <label class="form-label" for="relacion"><strong>Relación *:</strong></label>
                  <div class="input-group">
                    <ng-select #inputRelacion [items]="relaciones" bindLabel="relacion" bindValue="id"
                      (change)="onRelacionChange($event)" placeholder="Selecciona una opción"
                      class="js-example-placeholder-multiple" style="flex-grow: 1" formControlName="relacion"
                      [class.is-invalid]="
                      formNuevo.get('relacion')?.invalid &&
                      formNuevo.get('relacion')?.touched
                    ">
                    </ng-select>
                  </div>

                  <div *ngIf="
                    formNuevo.get('relacion')?.invalid &&
                    formNuevo.get('relacion')?.touched
                  " class="invalid-feedback">
                    {{ errores.relacion }}
                  </div>
                </div>
                <div class="col-md-6">
                  <label class="form-label"><strong>Empresa *:</strong></label>
                  <div class="input-group">
                    <div class="form-control p-0 border-0">
                      <ng-select #inputEmpresa [items]="empresas" bindLabel="nombre" bindValue="nit"
                        placeholder="Selecciona una opción" class="js-example-placeholder-multiple" style="flex-grow: 1"
                        formControlName="nitEmpresa" [class.is-invalid]="
                      formNuevo.get('nitEmpresa')?.invalid &&
                      formNuevo.get('nitEmpresa')?.touched
                    ">
                      </ng-select>
                    </div>
                    <button type="button" class="btn btn-primary btn-sm" (click)="openModalEmpresa(myModal)">
                      <i class="icofont icofont-plus"></i>
                    </button>
                  </div>
                  <div *ngIf="
                    formNuevo.get('nitEmpresa')?.invalid &&
                    formNuevo.get('nitEmpresa')?.touched
                  " class="invalid-feedback">
                    {{ errores.nitEmpresa }}
                  </div>
                </div>
                <div class="col-md-6">
                  <label class="form-label" for="Idpropietario"><strong>Propietario</strong></label>
                  <ng-select id="Idpropietario" [items]="propietarios" bindValue="cedula" bindLabel="cedula"
                    [searchFn]="buscarPropietario" placeholder="Selecciona una opción" formControlName="Idpropietario"
                    class="js-example-placeholder-multiple" style="flex-grow: 1">
                    <ng-template ng-option-tmp let-item="item">
                      {{ item.primernombre }} {{ item.segundonombre }} {{ item.papellidos }} {{ item.seapellidos |
                      uppercase }}
                      - {{ item.cedula }}
                    </ng-template>

                    <ng-template ng-label-tmp let-item="item">
                      {{ item.primernombre }} {{ item.segundonombre }} {{ item.papellidos }} {{ item.seapellidos |
                      uppercase }}
                      - {{ item.cedula }}
                    </ng-template>

                  </ng-select>
                </div>

             

                <div class="col-md-3">
                  <label class="form-label" for="conductor_id"><strong>Conductor *</strong></label>
                  <div class="input-group" formGroupName="conductor">
                    <div class="form-control p-0 border-0">
                      <ng-select id="conductor_id" [items]="propietarios" [searchFn]="searchConductor"
                        bindLabel="primernombre" bindValue="cedula" placeholder="Selecciona una opción"
                        class="js-example-placeholder-multiple" style="flex-grow: 1" formControlName="conductor_id"
                        [class.is-invalid]="
                        formNuevo.get('conductor.conductor_id')?.invalid &&
                        formNuevo.get('conductor.conductor_id')?.touched
                      ">
                        <ng-template ng-label-tmp let-item="item">
                          {{ getNombreCompleto(item) }}
                        </ng-template>

                        <ng-template ng-option-tmp let-item="item">
                          {{ getNombreCompleto(item) }}
                        </ng-template>

                      </ng-select>
                    </div>

                    <button type="button" class="btn btn-primary btn-sm" (click)="guardarConductor()">
                      <i class="icofont icofont-plus"></i>
                    </button>
                  </div>

                  <!-- Mensaje de validación -->
                  <div *ngIf="
                    formNuevo.get('conductor.conductor_id')?.invalid &&
                    formNuevo.get('conductor.conductor_id')?.touched
                  " class="invalid-feedback d-block">
                    Seleccione un conductor.
                  </div>
                </div>


                <div class="col-md-3">
                  <label class="form-label" for="sucursal"><strong>Sucursal oficina:</strong></label>
                  <div class="input-group">
                    <ng-select id="sucursal" name="sucursal" [items]="municipios" bindLabel="MUNICIPIO"
                      bindValue="IDMUN" placeholder="Selecciona una opción" class="js-example-placeholder-multiple"
                      style="flex-grow: 1" formControlName="sucursal">
                    </ng-select>
                  </div>
                </div>
                <div class="col-md-3" *ngIf="mostrarFechaConvenio">
                  <label class="form-label" for="convenio"><strong>Vigencia Convenio *:</strong></label>
                  <div class="input-group input-group-sm">
                    <input id="convenio" type="date" class="form-control form-control-lg fs-14" [min]="minDate"
                      formControlName="convenio" />
                  </div>
                  <div *ngIf="formNuevo.get('convenio')?.invalid && formNuevo.get('convenio')?.touched" class="invalid-feedback d-block">
                    La fecha de vigencia del convenio es obligatoria.
                  </div>
                </div>

                <div class="col-md-3">
                  <label class="form-label" for="password"><strong>Contraseña *:</strong></label>
                  <div class="input-group">
                    <input #inputPassword [type]="showPassword ? 'text' : 'password'" class="form-control" id="password"
                      placeholder="Ingrese una contraseña" required name="password" formControlName="password" autocomplete="new-password"
                      [class.is-invalid]="
                             formNuevo.get('password')?.invalid &&
                             formNuevo.get('password')?.touched
                           " />
                
                    <!-- Botón con ícono -->
                    <button type="button" class="btn btn-primary" (click)="showPassword = !showPassword">
                      <i [class]="showPassword ? 'icofont icofont-eye-alt' : 'icofont icofont-eye-blocked'"></i>
                    </button>
                
                    <div *ngIf="
                          formNuevo.get('password')?.invalid &&
                          formNuevo.get('password')?.touched
                        " class="invalid-feedback">
                      {{ errores.password }}
                    </div>
                  </div>
                </div>

                <div class="col-md-3">
                  <label class="form-label" for="kilometraje"><strong>Kilometraje Actual :</strong></label>
                  <input #inputKilometraje class="form-control" id="kilometraje" type="number"
                    placeholder="Ingrese KM actual" required="" formControlName="kilometraje" min="0"
                    autocomplete="off" [ngClass]="{
                    'is-invalid':
                      formNuevo.controls['kilometraje'].invalid &&
                      formNuevo.controls['kilometraje'].touched
                  }" />
                  <div *ngIf="
                    formNuevo.controls['kilometraje'].invalid &&
                    formNuevo.controls['kilometraje'].touched
                  " class="invalid-feedback">
                    {{ errores.kilometraje }}
                  </div>
                </div>

              </div>
            </form>




          </div>
          <div class="card-body custom-datatable noscroll">
            <div class="custom-datatable table-responsive">
              <table class="table table-hover table-bordered" id="tblConductor">
                <thead class="bg-primary">
                  <tr>
                    <th class="text-center" style="cursor: pointer"><strong>CEDULA</strong></th>
                    <th class="text-center" style="cursor: pointer">
                     <strong>NOMBRE COMPLETO</strong>
                    </th>
                    <th class="text-center" style="cursor: pointer">
                      <strong>ACCIONES</strong>
                    </th>
                  </tr>
                </thead>

                <tbody>
                  <tr *ngFor="let conductor of conductores">
                    <td class="text-center">{{ conductor.conductor_id }}</td>
                    <td class="text-uppercase text-center">
                      {{ conductor.propietario?.primernombre }}
                      {{ conductor.propietario?.segundonombre }}
                      {{ conductor.propietario?.papellidos }}
                      {{ conductor.propietario?.seapellidos }}
                    </td>

                    <!-- Buscar tarjeta correspondiente -->
                    <td>
                      <div class="action text-center">
                        <ul class="list-inline d-flex justify-content-center gap-3">
                          <li class="list-inline-item delete">
                            <a href="javascript:void(0)">
                              <i class="icon-trash"
                                (click)="avisoInactivarConductor(conductor.id)" ngbTooltip="Inactivar"></i>
                            </a>
                          </li>
                        </ul>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="d-flex justify-content-between align-items-center mt-4">
              <!-- Selector de registros por página alineado a la izquierda -->
              <div class="d-flex align-items-center">
                <label for="pageSize1" class="me-2">Mostrar:</label>
                <select id="pageSize1" class="form-select w-auto" [(ngModel)]="pageSize1" (change)="page1 = 1">
                  <option *ngFor="let size1 of [5, 10, 20, 50, 100]" [value]="size1">
                    {{ size1 }}
                  </option>
                </select>
                <span class="ms-2">registros por página</span>
              </div>

              <div class="mx-auto text-center">
                <span class="badge bg-primary ms-1"><b><span>Total Registros: </span>{{ conductores?.length || 0
                    }}</b></span>
              </div>
              <!-- Paginador alineado a la derecha -->
              <div class="text-end paginador-personalizado">
                <pagination-controls (pageChange)="page1 = $event" [maxSize]="5" [directionLinks]="true"
                  [autoHide]="true" previousLabel="Anterior" nextLabel="Siguiente">
                </pagination-controls>
              </div>
            </div>
            <div class="card-body">
              <div class="btn-showcase text-center">
                <button class="btn btn-outline-success-2x" type="button" placement="top" ngbTooltip="Exportar a Excel"
                  (click)="
                    exportarExcel(
                      'tblConductor',
                      'Listado_Conductor_Vehiculo'
                    )
                  ">
                  <i class="icofont icofont-file-excel"></i> EXCEL
                </button>

                <button class="btn btn-outline-danger-2x" type="button" placement="top" ngbTooltip="Exportar a PDF"
                  (click)="
                    exportToPDF(
                      'tblConductor',
                      'Listado_Conductor_Vehiculo',
                      'Listado de Conductor Vehiculo'
                    )
                  ">
                  <i class="icofont icofont-file-pdf"></i> PDF
                </button>
              </div>
            </div>
          </div>
        </div>
      </ng-template>
    </ngb-panel>

    <ngb-panel id="static-2" *ngIf="validarLT">
      <ng-template ngbPanelTitle>
        <i class="icofont icofont-id-card"></i>
        <span class="ms-2"><strong>LICENCIA DE TRANSITO (MATRICULA)</strong></span>
      </ng-template>
      <ng-template ngbPanelContent>
        <div class="card">
          <div class="card-body">
            <form [formGroup]="formNuevo">
              <div class="row g-3 mb-3">
                <div class="col-md-3">
                  <label class="form-label" for="matricula">
                   <strong>Número de matricula:</strong></label>
                  <input class="form-control" id="matricula" type="text" placeholder="Ingrese un número de matricula"
                    formControlName="matricula" autocomplete="off" />
                </div>
                <div class="col-md-3">
                  <label class="form-label" for="organismo">
                    <strong>Organismo de transito:</strong></label>
                  <input class="form-control" id="organismo" type="text" placeholder="Ingrese el organismo de transito"
                    formControlName="organismo" autocomplete="off" />
                </div>
                <div class="col-md-3">
                  <label class="form-label" for="fechalict"><strong>Fecha de expedición:</strong></label>
                  <div class="input-group input-group-sm">
                    <div class="input-group input-group-sm">
                      <input id="fechalict" type="date" class="form-control form-control-lg fs-14" name="convenio"
                        [max]="maxDate" formControlName="fechalict" autocomplete="off" />
                    </div>
                  </div>
                </div>
                <div class="col-md-3">
                  <label class="form-label" for="linea"> <strong>Linea:</strong></label>
                  <input class="form-control" id="linea" type="text" placeholder="Ingrese la linea"
                    formControlName="linea" autocomplete="off" />
                </div>

                <div class="col-md-3">
                  <label class="form-label" for="cilindraje"><strong>Cilindraje:</strong></label>
                  <input class="form-control" id="cilindraje" type="text" placeholder="Ingrese el cilindaje"
                    formControlName="cilindraje" autocomplete="off" />
                </div>
                <div class="col-md-3">
                  <label class="form-label" for="motor"><strong>Número motor:</strong></label>
                  <input class="form-control" id="motor" type="text" placeholder="Ingrese el número del motor"
                    formControlName="motor" autocomplete="off" />
                </div>
                <div class="col-md-3">
                  <label class="form-label" for="titular"><strong>Titular:</strong></label>
                  <input class="form-control" id="titular" type="text" placeholder="Ingrese un titular"
                    formControlName="titular" autocomplete="off" />
                </div>

                <div class="col-md-3">
                  <label class="form-label" for="capacidad"><strong>Capacidad:</strong></label>
                  <input class="form-control" id="capacidad" type="text" placeholder="Ingrese la capacidad"
                    formControlName="capacidad" autocomplete="off" />
                </div>
                <div class="col-md-3">
                  <label class="form-label" for="color"> <strong>Color:</strong></label>
                  <input class="form-control" id="color" type="text" placeholder="Ingrese el color"
                    formControlName="color" autocomplete="off" />
                </div>
                <div class="col-md-3">
                  <label class="form-label" for="serie"> <strong>Número serie:</strong></label>
                  <input class="form-control" id="serie" type="text" placeholder="Ingrese el número de serie"
                    formControlName="serie" autocomplete="off" />
                </div>
                <div class="col-md-3">
                  <label class="form-label" for="chasis"> <strong>Número chasís:</strong></label>
                  <input class="form-control" id="chasis" type="text" placeholder="Ingrese el número de chasís"
                    formControlName="chasis" autocomplete="off" />
                </div>

                

                <div class="col-md-3">
                  <label class="form-label" for="carroceria"> <strong>Carrocería:</strong></label>
                  <input class="form-control" id="carroceria" type="text" placeholder="Ingrese la carroceria"
                    formControlName="carroceria" autocomplete="off" />
                </div>

                <div class="col-md-3">
                  <label class="form-label" for="combustible"><strong>Tipo combustible:</strong></label>
                  <ng-select [items]="combustibles" bindLabel="nombre" bindValue="id" placeholder="Seleciona una opción"
                    class="js-example-placeholder-multiple" formControlName="combustible">
                  </ng-select>
                </div>
                <div class="col-md-3">
                  <label class="form-label" for="vin"> <strong>VIN:</strong></label>
                  <input class="form-control" id="vin" type="text" placeholder="Ingrese el VIN"
                    formControlName="vin" autocomplete="off" />
                </div>
                <div class="col-md-3">
                  <label class="form-label" for="observaciones">
                    <strong>Observaciones:</strong></label>
                  <input class="form-control" id="observaciones" type="text" placeholder="Ingrese observaciones"
                    formControlName="observaciones" autocomplete="off" />
                </div>
              </div>
            </form>
          </div>
        </div>
      </ng-template>
    </ngb-panel>

    <ngb-panel id="static-3" *ngIf="validarTO">
      <ng-template ngbPanelTitle>
        <i class="icon-id-badge"></i>
        <span class="ms-2 text-uppercase"><strong>Tarjeta de Operación:</strong></span>
      </ng-template>
      <ng-template ngbPanelContent>
        <div class="card">


          <div class="card-body custom-datatable noscroll">
            <div class="custom-datatable table-responsive">
              <table class="table table-hover table-bordered" id="tblTarjetaOperación">
                <thead class="bg-primary">
                  <tr>
                    <!-- <th class="text-center" style="cursor: pointer">ID</th> -->
                    <th class="text-center" style="cursor: pointer"><strong>PLACA:</strong></th>
                    <th class="text-center" style="cursor: pointer"><strong>NÚMERO DE TARJETA:</strong></th>
                    <th class="text-center" style="cursor: pointer"><strong>FECHA DE EXPEDICIÓN:</strong></th>
                    <th class="text-center" style="cursor: pointer"><strong>FECHA DE VENCIMIENTO:</strong></th>
                    <th class="text-center" style="cursor: pointer"><strong>DIAS POR VENCER:</strong></th>
                    <th class="text-center" style="cursor: pointer"><strong>ESTADO:</strong></th>
                    <th class="text-center" style="cursor: pointer"><strong>ACCIONES:</strong></th>
                  </tr>
                </thead>

                <tbody>
                  <tr
                    *ngFor="let tarjeta of tarjetaOperacion | paginate: { itemsPerPage: pageSize1, currentPage: page1 }">
                    <!--  <td class="text-center">{{ tarjeta.id }}</td> -->
                    <td class="text-center">{{ tarjeta.placa }}</td>
                    <td class="text-center">{{ tarjeta.numero_tarjeta }}</td>
                    <td class="text-center">{{ tarjeta.fecha_expedicion | date:'dd/MM/yyyy'}}</td>
                    <td class="text-center">{{ tarjeta.fecha_vencimiento | date:'dd/MM/yyyy'}}</td>
                    <td class="text-center">{{ tarjeta.estadoCalculado.diasRestantes }}</td>
                    <td class="text-center text-uppercase">
                      <span class="badge" [ngClass]="getEstadoColor(tarjeta.estadoCalculado.estado)">
                        {{ tarjeta.estado_fechas | uppercase }}
                      </span>
                    </td>

                    <!-- Buscar tarjeta correspondiente -->
                    <td class="text-center align-middle">
                      <div class="action d-flex justify-content-center">
                        <ul class="list-inline d-flex align-items-center gap-2 mb-0">

                          <!-- Botón Editar (Solo si puede editar) -->
                          <li class="list-inline-item edit" *ngIf="puedeEditar(tarjeta)">
                            <a href="javascript:void(0)">
                              <i class="icon-pencil-alt" (click)="openModalTarjetaOperacion(myModal3, tarjeta?.id)"
                                ngbTooltip="Editar"></i>
                            </a>
                          </li>

                          <!-- Botón Eliminar -->
                          <li class="list-inline-item delete">
                            <a href="javascript:void(0)">
                              <i class="icon-trash" (click)="actualizarEstadoAInactivo(tarjeta.numero_tarjeta)"
                                ngbTooltip="Inactivar"></i>
                            </a>
                          </li>

                        </ul>
                      </div>
                    </td>



                  </tr>
                </tbody>
              </table>
            </div>
            <div class="d-flex justify-content-between align-items-center mt-4">
              <!-- Selector de registros por página alineado a la izquierda -->
              <div class="d-flex align-items-center">
                <label for="pageSize1" class="me-2">Mostrar:</label>
                <select id="pageSize1" class="form-select w-auto" [(ngModel)]="pageSize1" (change)="page1 = 1">
                  <option *ngFor="let size1 of [5, 10, 20, 50, 100]" [value]="size1">{{ size1 }}</option>
                </select>
                <span class="ms-2">registros por página</span>
              </div>

              <div class="mx-auto text-center">
                <span class="badge bg-primary ms-1"><b><span>Total Registros: </span>{{ tarjetaOperacion?.length || 0
                    }}</b></span>
              </div>

              <!-- Paginador alineado a la derecha -->
              <div class="text-end paginador-personalizado">
                <pagination-controls (pageChange)="page1 = $event" [maxSize]="5" [directionLinks]="true"
                  [autoHide]="true" previousLabel="Anterior" nextLabel="Siguiente">
                </pagination-controls>
              </div>
            </div>
            <div class="card-body">
              <div class="btn-showcase text-center">
                <button class="btn btn-outline-success-2x" type="button" placement="top" ngbTooltip="Exportar a Excel"
                  (click)="
                    exportarExcel(
                      'tblTarjetaOperación',
                      'Listado_Tarjeta_Operación'
                    )
                  ">
                  <i class="icofont icofont-file-excel"></i> EXCEL
                </button>

                <button class="btn btn-outline-danger-2x" type="button" placement="top" ngbTooltip="Exportar a PDF"
                  (click)="
                    exportToPDF(
                      'tblTarjetaOperación',
                      'Listado_Tarjeta_Operación',
                      'Listado de Tarjeta Operación'
                    )
                  ">
                  <i class="icofont icofont-file-pdf"></i> PDF
                </button>

                <button class="btn btn-outline-primary-2x" type="button" placement="top"
                  ngbTooltip="Renovar Tarjeta de Operación" (click)="openModalTarjetaOperacion(myModal3)">
                  <i class="icofont icofont-refresh"></i> Renovar
                </button>
              </div>
            </div>
          </div>
        </div>
      </ng-template>
    </ngb-panel>

    <ngb-panel id="static-4" *ngIf="validarSOAT">
      <ng-template ngbPanelTitle>
        <i class="icofont icofont-safety"></i>
        <span class="ms-2 text-uppercase"><strong>Seguro Obligatario (SOAT):</strong></span>
      </ng-template>
      <ng-template ngbPanelContent>
        <div class="card">
          <div class="card-body custom-datatable noscroll">
            <div class="custom-datatable table-responsive">
              <table class="table table-hover table-bordered" id="tblSoat">
                <thead class="bg-primary">
                  <tr>
                    <!--  <th class="text-center" style="cursor: pointer">ID</th> -->
                    <th class="text-center" style="cursor: pointer"><strong>PLACA:</strong></th>
                    <th class="text-center" style="cursor: pointer"><strong>NÚMERO:</strong></th>
                    <th class="text-center" style="cursor: pointer"><strong>ASEGURADORA:</strong></th>
                    <th class="text-center" style="cursor: pointer"><strong>FECHA DE EXPEDICIÓN:</strong></th>
                    <th class="text-center" style="cursor: pointer"><strong>FECHA DE VENCIMIENTO:</strong></th>
                    <th class="text-center" style="cursor: pointer"><strong>VALOR:</strong></th>
                    <th class="text-center" style="cursor: pointer"><strong>TARIFA:</strong></th>
                    <th class="text-center" style="cursor: pointer"><strong>DIAS POR VENCER:</strong></th>
                    <th class="text-center" style="cursor: pointer"><strong>ESTADO:</strong></th>
                    <th class="text-center" style="cursor: pointer"><strong>ACCIONES:</strong></th>
                  </tr>
                </thead>

                <tbody>
                  <tr *ngFor="let soat of soatList | paginate: { itemsPerPage: pageSize1, currentPage: page1 }">
                   <!--   <td class="text-center">{{ soat.id }}</td>  -->
                    <td class="text-center">{{ soat.placa }}</td>
                    <td class="text-center">{{ soat.id_soat }}</td>
                    <td class="text-center">{{ soat.empresa?.nombre }}</td>
                    <td class="text-center">{{ soat.fecha_soat | date:'dd/MM/yyyy' }}</td>
                    <td class="text-center">{{ soat.vencimiento_soat | date:'dd/MM/yyyy' }}</td>
                    <td class="text-center">{{ soat.valor }}</td>
                    <td class="text-center">{{ soat.tarifa }}</td>
                    <td class="text-center">{{ soat.estadoCalculado.diasRestantes }}</td>
                    <td class="text-center">
                      <span [ngClass]="getEstadoColor(soat.estadoCalculado.estado)">
                        {{ soat.estadoCalculado.estado | uppercase}}
                      </span>
                    </td>
                    <td class="text-center align-middle">
                      <div class="action d-flex justify-content-center">
                        <ul class="list-inline d-flex align-items-center gap-2 mb-0">

                          <!-- Botón Editar (Solo si puede editar) -->
                          <li class="list-inline-item edit" *ngIf="puedeEditarSoat(soat)">
                            <a href="javascript:void(0)">
                              <i class="icon-pencil-alt" (click)="openModalSoat(myModal4, soat?.id)"
                                ngbTooltip="Editar"></i>
                            </a>
                          </li>

                          <!-- Botón Eliminar -->
                          <li class="list-inline-item delete">
                            <a href="javascript:void(0)">
                              <i class="icon-trash" (click)="actualizarEstadoAInactivoSoat(soat?.id)"
                                ngbTooltip="Inactivar"></i>
                            </a>
                          </li>

                        </ul>
                      </div>
                    </td>


                  </tr>

                </tbody>
              </table>
            </div>
            <div class="d-flex justify-content-between align-items-center mt-4">
              <!-- Selector de registros por página alineado a la izquierda -->
              <div class="d-flex align-items-center">
                <label for="pageSize1" class="me-2">Mostrar:</label>
                <select id="pageSize1" class="form-select w-auto" [(ngModel)]="pageSize1" (change)="page1 = 1">
                  <option *ngFor="let size1 of [5, 10, 20, 50, 100]" [value]="size1">
                    {{ size1 }}
                  </option>
                </select>
                <span class="ms-2">registros por página</span>
              </div>

              <!-- Mostrar cantidad total de registros centrado -->
              <div class="mx-auto text-center">
                <span class="badge bg-primary ms-1"><b><span>Total Registros: </span>{{ soatList.length || 0
                    }}</b></span>
              </div>
              <!-- Paginador alineado a la derecha -->
              <div class="text-end paginador-personalizado">
                <pagination-controls (pageChange)="page1 = $event" [maxSize]="5" [directionLinks]="true"
                  [autoHide]="true" previousLabel="Anterior" nextLabel="Siguiente">
                </pagination-controls>
              </div>
            </div>
            <div class="card-body">
              <div class="btn-showcase text-center">
                <button class="btn btn-outline-success-2x" type="button" placement="top" ngbTooltip="Exportar a Excel"
                  (click)="
                    exportarExcel(
                      'tblSoat',
                      'Listado_Soat'
                    )
                  ">
                  <i class="icofont icofont-file-excel"></i> EXCEL
                </button>

                <button class="btn btn-outline-danger-2x" type="button" placement="top" ngbTooltip="Exportar a PDF"
                  (click)="
                    exportToPDF(
                      'tblSoat',
                      'Listado_Soat',
                      'Listado de Soat'
                    )
                  ">
                  <i class="icofont icofont-file-pdf"></i> PDF
                </button>

                <button class="btn btn-outline-primary-2x" type="button" placement="top" ngbTooltip="Renovar Soat"
                  (click)="openModalSoat(myModal4)">
                  <i class="icofont icofont-refresh"></i> Renovar
                </button>
              </div>
            </div>
          </div>
        </div>
      </ng-template>
    </ngb-panel>

    <ngb-panel id="static-5" *ngIf="validarCDA">
      <ng-template ngbPanelTitle>
        <i class="icofont icofont-tools-alt-2"></i>
        <span class="ms-2 text-uppercase"><strong>Revisión Técnico Mecánica (RTM)</strong></span>
      </ng-template>
      <ng-template ngbPanelContent>
        <div class="col-sm-12 col-xl-12">
          <ul ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-tabs">
            <li [ngbNavItem]="1" class="nav-tabs">
              <a ngbNavLink class="text-primary"><strong>HISTORIAL RTM</strong></a>
              <ng-template ngbNavContent>
                <div class="card">

                  <div class="card-body custom-datatable noscroll">
                    <div class="custom-datatable table-responsive">
                      <table class="table table-hover table-bordered" id="tblCDA">
                        <thead class="bg-primary">
                          <tr>
                            <!--  <th class="text-center" style="cursor: pointer">ID</th> -->
                            <th class="text-center" style="cursor: pointer"><strong>PLACA</strong></th>
                            <th class="text-center" style="cursor: pointer"><strong>NÚMERO</strong></th>
                            <th class="text-center" style="cursor: pointer"><strong>CENTRO CDA</strong></th>
                            <th class="text-center" style="cursor: pointer"><strong>FECHA EXPEDICIÓN</strong></th>
                            <th class="text-center" style="cursor: pointer"><strong>FECHA VENCIMIENTO</strong></th>
                            <th class="text-center" style="cursor: pointer"><strong>DIAS POR VENCER</strong></th>
                            <th class="text-center" style="cursor: pointer"><strong>ESTADO</strong></th>
                            <th class="text-center" style="cursor: pointer"><strong>ACCIONES</strong></th>
                          </tr>
                        </thead>

                        <tbody>
                          <tr
                            *ngFor="let cda of historialCda | paginate: { itemsPerPage: pageSize1, currentPage: page1 }">
                            <!--  <td class="text-center">{{ cda.id }}</td> -->
                            <td class="text-center">{{ cda.placa }}</td>
                            <td class="text-center">{{ cda.idcda }}</td>
                            <td class="text-center">{{ cda.empresa?.nombre }}</td>
                            <td class="text-center">{{ cda.fechacda | date:'dd/MM/yyyy' }}</td>
                            <td class="text-center">{{ cda.vcda | date:'dd/MM/yyyy' }}</td>
                            <td class="text-center">{{ cda.estadoCalculado.diasRestantes }}</td>
                            <td class="text-center">
                              <span [ngClass]="getEstadoColor(cda.estadoCalculado.estado)">
                                {{ cda.estadoCalculado.estado | uppercase }}
                              </span>
                            </td>
                            <td class="text-center align-middle">
                              <div class="action d-flex justify-content-center">
                                <ul class="list-inline d-flex align-items-center gap-2 mb-0">

                                  <!-- Botón Editar (Solo si puede editar) -->
                                  <li class="list-inline-item edit" *ngIf="puedeEditarCda(cda)">
                                    <a href="javascript:void(0)">
                                      <i class="icon-pencil-alt" (click)="openModalCda(myModal5, cda?.id)"
                                        ngbTooltip="Editar"></i>
                                    </a>
                                  </li>

                                  <!-- Botón Eliminar -->
                                  <li class="list-inline-item delete">
                                    <a href="javascript:void(0)">
                                      <i class="icon-trash" (click)="actualizarEstadoAInactivoCda(cda.id)"
                                        ngbTooltip="Inactivar"></i>
                                    </a>
                                  </li>

                                </ul>
                              </div>
                            </td>


                          </tr>

                        </tbody>
                      </table>
                    </div>
                    <div class="d-flex justify-content-between align-items-center mt-4">
                      <!-- Selector de registros por página alineado a la izquierda -->
                      <div class="d-flex align-items-center">
                        <label for="pageSize1" class="me-2">Mostrar:</label>
                        <select id="pageSize1" class="form-select w-auto" [(ngModel)]="pageSize1" (change)="page1 = 1">
                          <option *ngFor="let size1 of [5, 10, 20, 50, 100]" [value]="size1">
                            {{ size1 }}
                          </option>
                        </select>
                        <span class="ms-2">registros por página</span>
                      </div>

                      <!-- Mostrar cantidad total de registros centrado -->
                      <div class="mx-auto text-center">
                        <span class="badge bg-primary ms-1"><b><span>Total Registros: </span>{{ historialCda.length || 0
                            }}</b></span>
                      </div>

                      <!-- Paginador alineado a la derecha -->
                      <div class="text-end paginador-personalizado">
                        <pagination-controls (pageChange)="page1 = $event" [maxSize]="5" [directionLinks]="true"
                          [autoHide]="true" previousLabel="Anterior" nextLabel="Siguiente">
                        </pagination-controls>
                      </div>
                    </div>
                    <div class="card-body">
                      <div class="btn-showcase text-center">
                        <button class="btn btn-outline-success-2x" type="button" placement="top"
                          ngbTooltip="Exportar a Excel" (click)="
                            exportarExcel(
                              'tblCDA',
                              'Listado_Cda'
                            )
                          ">
                          <i class="icofont icofont-file-excel"></i> EXCEL
                        </button>

                        <button class="btn btn-outline-danger-2x" type="button" placement="top"
                          ngbTooltip="Exportar a PDF" (click)="
                            exportToPDF(
                              'tblCDA',
                              'Listado_Cda',
                              'Listado de Cda'
                            )
                          ">
                          <i class="icofont icofont-file-pdf"></i> PDF
                        </button>

                        <button class="btn btn-outline-primary-2x" type="button" placement="top"
                          ngbTooltip="Renovar RTM" (click)="openModalCda(myModal5)">
                          <i class="icofont icofont-refresh"></i> Renovar
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-template>
            </li>
            <li [ngbNavItem]="2" class="nav-tabs">
              <a ngbNavLink class="text-primary"><strong>HISTORIAL EXTINTOR</strong></a>
              <ng-template ngbNavContent>
                <div class="card">


                  <div class="card-body custom-datatable noscroll">
                    <div class="custom-datatable table-responsive">
                      <table class="table table-hover table-bordered" id="tblExtintor">
                        <thead class="bg-primary">
                          <tr>
                            <!--  <th class="text-center" style="cursor: pointer">ID</th> -->
                            <th class="text-center" style="cursor: pointer"><strong>PLACA</strong></th>
                            <th class="text-center" style="cursor: pointer"><strong>NÚMERO</strong></th>
                            <th class="text-center" style="cursor: pointer"><strong>RECARGA EXTINTOR</strong></th>
                            <th class="text-center" style="cursor: pointer"><strong>FECHA VENCIMIENTO</strong></th>
                            <th class="text-center" style="cursor: pointer"><strong>DIAS POR VENCER</strong></th>
                            <th class="text-center" style="cursor: pointer"><strong>ESTADO</strong></th>
                            <th class="text-center" style="cursor: pointer"><strong>ACCIONES</strong></th>
                          </tr>
                        </thead>

                        <tbody>
                          <tr
                            *ngFor="let ext of historialExtintor | paginate: { itemsPerPage: pageSize1, currentPage: page1 }">
                            <!--  <td class="text-center">{{ ext.id }}</td> -->
                            <td class="text-center">{{ ext.placa }}</td>
                            <td class="text-center">{{ ext.idextintor }}</td>
                            <td class="text-center">{{ ext.frecarga | date:'dd/MM/yyyy' }}</td>
                            <td class="text-center">{{ ext.vrecarga | date:'dd/MM/yyyy' }}</td>
                            <td class="text-center">{{ ext.estadoCalculado.diasRestantes }}</td>
                            <td class="text-center">
                              <span [ngClass]="getEstadoColor(ext.estadoCalculado.estado)">
                                {{ ext.estadoCalculado.estado | uppercase }}
                              </span>
                            </td>
                            <td class="text-center align-middle">
                              <div class="action d-flex justify-content-center">
                                <ul class="list-inline mb-0 d-flex align-items-center gap-2">

                                  <!-- Botón Editar (Solo si puede editar) -->
                                  <li class="list-inline-item edit" *ngIf="puedeEditarExtintor(ext)">
                                    <a href="javascript:void(0)">
                                      <i class="icon-pencil-alt" (click)="openModalExtintor(myModal6, ext?.id)"
                                        ngbTooltip="Editar"></i>
                                    </a>
                                  </li>

                                  <!-- Botón Eliminar -->
                                  <li class="list-inline-item delete">
                                    <a href="javascript:void(0)">
                                      <i class="icon-trash" (click)="actualizarEstadoAInactivoExtintor(ext?.id)"
                                        ngbTooltip="Inactivar"></i>
                                    </a>
                                  </li>

                                </ul>
                              </div>
                            </td>


                          </tr>

                        </tbody>
                      </table>
                    </div>
                    <div class="d-flex justify-content-between align-items-center mt-4">
                      <!-- Selector de registros por página alineado a la izquierda -->
                      <div class="d-flex align-items-center">
                        <label for="pageSize1" class="me-2">Mostrar:</label>
                        <select id="pageSize1" class="form-select w-auto" [(ngModel)]="pageSize1" (change)="page1 = 1">
                          <option *ngFor="let size1 of [5, 10, 20, 50, 100]" [value]="size1">
                            {{ size1 }}
                          </option>
                        </select>
                        <span class="ms-2">registros por página</span>
                      </div>

                      <!-- Mostrar cantidad total de registros centrado -->
                      <div class="mx-auto text-center">
                        <span class="badge bg-primary ms-1"><b><span>Total Registros: </span>{{ historialExtintor.length
                            || 0 }}</b></span>
                      </div>

                      <!-- Paginador alineado a la derecha -->
                      <div class="text-end paginador-personalizado">
                        <pagination-controls (pageChange)="page1 = $event" [maxSize]="5" [directionLinks]="true"
                          [autoHide]="true" previousLabel="Anterior" nextLabel="Siguiente">
                        </pagination-controls>
                      </div>
                    </div>
                    <div class="card-body">
                      <div class="btn-showcase text-center">
                        <button class="btn btn-outline-success-2x" type="button" placement="top"
                          ngbTooltip="Exportar a Excel" (click)="
                            exportarExcel(
                              'tblExtintor',
                              'Listado_Extintor'
                            )
                          ">
                          <i class="icofont icofont-file-excel"></i> EXCEL
                        </button>

                        <button class="btn btn-outline-danger-2x" type="button" placement="top"
                          ngbTooltip="Exportar a PDF" (click)="
                            exportToPDF(
                              'tblExtintor',
                              'Listado_Extintor',
                              'Listado de Extintor'
                            )
                          ">
                          <i class="icofont icofont-file-pdf"></i> PDF
                        </button>

                        <button class="btn btn-outline-primary-2x" type="button" placement="top"
                          ngbTooltip="Renovar Extintor" (click)="openModalExtintor(myModal6)">
                          <i class="icofont icofont-plus"></i> Renovar
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-template>
            </li>
          </ul>
          <div [ngbNavOutlet]="nav" class="mt-2"></div>
        </div>
      </ng-template>
    </ngb-panel>

    <ngb-panel id="static-6" *ngIf="validarBIM">
      <ng-template ngbPanelTitle>
        <i class="icofont icofont-check-circled"></i>
        <span class="ms-2 text-uppercase"><strong>Revisión Bimestral</strong></span>
      </ng-template>
      <ng-template ngbPanelContent>
        <div class="card">
          <div class="card-body custom-datatable noscroll">
            <div class="custom-datatable table-responsive">
              <table class="table table-hover table-bordered" id="tblBimestral">
                <thead class="bg-primary">
                  <tr>
                    <!--  <th class="text-center" style="cursor: pointer">ID</th> -->
                    <th class="text-center" style="cursor: pointer"><strong>PLACA</strong></th>
                    <th class="text-center" style="cursor: pointer"><strong>CENTRO DE DIAGNOSTICO</strong></th>
                    <th class="text-center" style="cursor: pointer"><strong>REVISIÓN</strong></th>
                    <th class="text-center" style="cursor: pointer"><strong>ÚLTIMA REVISIÓN</strong></th>
                    <th class="text-center" style="cursor: pointer"><strong>PRÓXIMA REVISIÓN</strong></th>
                    <th class="text-center" style="cursor: pointer"><strong>DIAS POR VENCER</strong></th>
                    <th class="text-center" style="cursor: pointer"><strong>ESTADO</strong></th>
                    <th class="text-center" style="cursor: pointer"><strong>ACCIONES</strong></th>
                  </tr>
                </thead>

                <tbody>
                  <tr
                    *ngFor="let rev of historialBimestral | paginate: { itemsPerPage: pageSize1, currentPage: page1 }">
                    <!--  <td class="text-center">{{ rev.id }}</td> -->
                    <td class="text-center">{{ rev.placa }}</td>
                    <td class="text-center">{{ rev.empresa.nombre }}</td>
                    <td class="text-center">{{ rev.revision_aprobada === '1' || rev.revision_aprobada === 1 ? 'Aprobada'
                      : 'Rechazada' }}</td>
                    <td class="text-center">{{ rev.ultima_revision | date:'dd/MM/yyyy' }}</td>
                    <td class="text-center">{{ rev.proxima_revision | date:'dd/MM/yyyy' }}</td>
                    <td class="text-center">{{ rev.estadoCalculado.diasRestantes }}</td>
                    <td class="text-center">
                      <span [ngClass]="getEstadoColor(rev.estadoCalculado.estado)">
                        {{ rev.estadoCalculado.estado | uppercase }}
                      </span>
                    </td>
                    <td>
                      <div class="action">
                        <ul class="list-inline d-flex w-100">

                          <!-- Botón Editar (Solo si puede editar) -->
                          <li class="list-inline-item edit me-auto" *ngIf="puedeEditarBimestral(rev)">
                            <a href="javascript:void(0)">
                              <i class="icon-pencil-alt" (click)="openModalBimestral(myModal7, rev?.id)"
                                ngbTooltip="Editar"></i>
                            </a>
                          </li>

                          <!-- Botón Eliminar (Aparece donde estaba Listar si Listar no está) -->
                          <li class="list-inline-item delete" [class.ms-auto]="botonListarDisponible">
                            <a href="javascript:void(0)">
                              <i class="icon-trash" (click)="actualizarEstadoAInactivoBimestral(rev.id)"
                                ngbTooltip="Inactivar"></i>
                            </a>
                          </li>

                        </ul>
                      </div>
                    </td>


                  </tr>

                </tbody>
              </table>
            </div>
            <div class="d-flex justify-content-between align-items-center mt-4">
              <!-- Selector de registros por página alineado a la izquierda -->
              <div class="d-flex align-items-center">
                <label for="pageSize1" class="me-2">Mostrar:</label>
                <select id="pageSize1" class="form-select w-auto" [(ngModel)]="pageSize1" (change)="page1 = 1">
                  <option *ngFor="let size1 of [5, 10, 20, 50, 100]" [value]="size1">
                    {{ size1 }}
                  </option>
                </select>
                <span class="ms-2">registros por página</span>
              </div>

              <!-- Mostrar cantidad total de registros centrado -->
              <div class="mx-auto text-center">
                <span class="badge bg-primary ms-1"><b><span>Total Registros: </span>{{ historialBimestral.length || 0
                    }}</b></span>
              </div>

              <!-- Paginador alineado a la derecha -->
              <div class="text-end paginador-personalizado">
                <pagination-controls (pageChange)="page1 = $event" [maxSize]="5" [directionLinks]="true"
                  [autoHide]="true" previousLabel="Anterior" nextLabel="Siguiente">
                </pagination-controls>
              </div>
            </div>
            <div class="card-body">
              <div class="btn-showcase text-center">
                <button class="btn btn-outline-success-2x" type="button" placement="top" ngbTooltip="Exportar a Excel"
                  (click)="
                    exportarExcel(
                      'tblBimestral',
                      'Listado_Bimestral'
                    )
                  ">
                  <i class="icofont icofont-file-excel"></i> EXCEL
                </button>

                <button class="btn btn-outline-danger-2x" type="button" placement="top" ngbTooltip="Exportar a PDF"
                  (click)="
                    exportToPDF(
                      'tblBimestral',
                      'Listado_Bimestral',
                      'Listado Bimestral'
                    )
                  ">
                  <i class="icofont icofont-file-pdf"></i> PDF
                </button>

                <button class="btn btn-outline-primary-2x" type="button" placement="top" ngbTooltip="Renovar Bimestral"
                  (click)="openModalBimestral(myModal7)">
                  <i class="icofont icofont-refresh"></i> Renovar
                </button>
              </div>
            </div>
          </div>
        </div>
      </ng-template>
    </ngb-panel>

    <ngb-panel id="static-7" *ngIf="validarRCC || validarRCE || validarPTR">
      <ng-template ngbPanelTitle>
        <i class="icofont icofont-building-alt"></i>
        <span class="ms-2 text-uppercase"><strong>Pólizas Legales</strong></span>
      </ng-template>
      <ng-template ngbPanelContent>
        <div class="col-sm-12 col-xl-12">
          <ul ngbNav #nav="ngbNav" [(activeId)]="active2" class="nav-tabs">
            <li [ngbNavItem]="3" class="nav-tabs" *ngIf="validarRCC">
              <a ngbNavLink class="text-primary text-uppercase"><strong>HISTORIA PÓLIZA RCC</strong></a>
              <ng-template ngbNavContent>
                <div class="card">
                  <div class="card-body custom-datatable noscroll">
                    <div class="custom-datatable table-responsive">
                      <table class="table table-hover table-bordered" id="tblContractual">
                        <thead class="bg-primary">
                          <tr>
                            <!-- <th class="text-center" style="cursor: pointer">ID</th> -->
                            <th class="text-center" style="cursor: pointer"><strong>PLACA</strong></th>
                            <th class="text-center" style="cursor: pointer"><strong>NÚMERO</strong></th>
                            <th class="text-center" style="cursor: pointer"><strong>ASEGURADORA</strong></th>
                            <th class="text-center" style="cursor: pointer"><strong>INTERMEDIARIA</strong></th>
                            <th class="text-center" style="cursor: pointer"><strong>FECHA EXPEDICIÓN</strong></th>
                            <th class="text-center" style="cursor: pointer"><strong>FECHA VENCIMIENTO</strong></th>
                            <th class="text-center" style="cursor: pointer"><strong>DIAS POR VENCER</strong></th>
                            <th class="text-center" style="cursor: pointer"><strong>ESTADO</strong></th>
                            <th class="text-center" style="cursor: pointer"><strong>ACCIONES</strong></th>
                          </tr>
                        </thead>

                        <tbody>
                          <tr
                            *ngFor="let cont of historialContractual | paginate: { itemsPerPage: pageSize1, currentPage: page1 }">
                            <!--  <td class="text-center">{{ cont.id }}</td> -->
                            <td class="text-center">{{ cont.placa }}</td>
                            <td class="text-center">{{ cont.numeroRCC }}</td>
                            <td class="text-center">{{ cont.empresa?.nombre }}</td>
                            <td class="text-center">{{ cont.intermediariaRCC }}</td>
                            <td class="text-center">{{ cont.fecha_expedicionRCC | date:'dd/MM/yyyy' }}</td>
                            <td class="text-center">{{ cont.fecha_vencimientoRCC | date:'dd/MM/yyyy' }}</td>
                            <td class="text-center">{{ cont.estadoCalculado.diasRestantes }}</td>
                            <td class="text-center">
                              <span [ngClass]="getEstadoColor(cont.estadoCalculado.estado)">
                                {{ cont.estadoCalculado.estado | uppercase }}
                              </span>
                            </td>
                            <td class="text-center align-middle">
                              <div class="action d-flex justify-content-center">
                                <ul class="list-inline d-flex gap-2 m-0">

                                  <!-- Botón Editar (Solo si puede editar) -->
                                  <li class="list-inline-item edit" *ngIf="puedeEditarBimestral(cont)">
                                    <a href="javascript:void(0)">
                                      <i class="icon-pencil-alt" (click)="openModalContractual(myModal8, cont?.id)"
                                        ngbTooltip="Editar"></i>
                                    </a>
                                  </li>

                                  <!-- Botón Eliminar -->
                                  <li class="list-inline-item delete">
                                    <a href="javascript:void(0)">
                                      <i class="icon-trash" (click)="inactivarPorIdContractual(cont.id)"
                                        ngbTooltip="Inactivar"></i>
                                    </a>
                                  </li>

                                </ul>
                              </div>
                            </td>
                          </tr>

                        </tbody>
                      </table>
                    </div>
                    <div class="d-flex justify-content-between align-items-center mt-4">
                      <!-- Selector de registros por página alineado a la izquierda -->
                      <div class="d-flex align-items-center">
                        <label for="pageSize1" class="me-2">Mostrar:</label>
                        <select id="pageSize1" class="form-select w-auto" [(ngModel)]="pageSize1" (change)="page1 = 1">
                          <option *ngFor="let size1 of [5, 10, 20, 50, 100]" [value]="size1">
                            {{ size1 }}
                          </option>
                        </select>
                        <span class="ms-2">registros por página</span>
                      </div>

                      <!-- Mostrar cantidad total de registros centrado -->
                      <div class="mx-auto text-center">
                        <span class="badge bg-primary ms-1"><b><span>Total Registros: </span>{{
                            historialContractual?.length || 0 }}</b></span>
                      </div>

                      <!-- Paginador alineado a la derecha -->
                      <div class="text-end paginador-personalizado">
                        <pagination-controls (pageChange)="page1 = $event" [maxSize]="5" [directionLinks]="true"
                          [autoHide]="true" previousLabel="Anterior" nextLabel="Siguiente">
                        </pagination-controls>
                      </div>
                    </div>
                    <div class="card-body">
                      <div class="btn-showcase text-center">
                        <button class="btn btn-outline-success-2x" type="button" placement="top"
                          ngbTooltip="Exportar a Excel" (click)="
                            exportarExcel(
                              'tblContractual',
                              'Listado_Contractual'
                            )
                          ">
                          <i class="icofont icofont-file-excel"></i> EXCEL
                        </button>

                        <button class="btn btn-outline-danger-2x" type="button" placement="top"
                          ngbTooltip="Exportar a PDF" (click)="
                            exportToPDF(
                              'tblContractual',
                              'Listado_Contractual',
                              'Listado de Contractual'
                            )
                          ">
                          <i class="icofont icofont-file-pdf"></i> PDF
                        </button>

                        <button class="btn btn-outline-primary-2x" type="button" placement="top" ngbTooltip="Renovar"
                          (click)="openModalContractual(myModal8)">
                          <i class="icofont icofont-refresh"></i> Renovar
                        </button>
                      </div>
                    </div>
                  </div>

                </div>
              </ng-template>
            </li>
            <li [ngbNavItem]="4" class="nav-tabs" *ngIf="validarRCE">
              <a ngbNavLink class="text-primary text-uppercase"><strong>HISTORIAL PÓLIZA RCE</strong></a>
              <ng-template ngbNavContent>
                <div class="card">
                  <div class="card-body custom-datatable noscroll">
                    <div class="custom-datatable table-responsive">
                      <table class="table table-hover table-bordered" id="tblExtraContractual">
                        <thead class="bg-primary">
                          <tr>
                            <!--  <th class="text-center" style="cursor: pointer">ID</th> -->
                            <th class="text-center" style="cursor: pointer"><strong>PLACA</strong></th>
                            <th class="text-center" style="cursor: pointer"><strong>NÚMERO</strong></th>
                            <th class="text-center" style="cursor: pointer"><strong>ASEGURADORA</strong></th>
                            <th class="text-center" style="cursor: pointer"><strong>INTERMEDIARIA</strong></th>
                            <th class="text-center" style="cursor: pointer"><strong>FECHA EXPEDICIÓN</strong></th>
                            <th class="text-center" style="cursor: pointer"><strong>FECHA VENCIMIENTO</strong></th>
                            <th class="text-center" style="cursor: pointer"><strong>DIAS POR VENCER</strong></th>
                            <th class="text-center" style="cursor: pointer"><strong>ESTADO</strong></th>
                            <th class="text-center" style="cursor: pointer"><strong>ACCIONES</strong></th>
                          </tr>
                        </thead>

                        <tbody>
                          <tr
                            *ngFor="let extra of historialExtracontractual | paginate: { itemsPerPage: pageSize1, currentPage: page1 }">
                            <!--  <td class="text-center">{{ extra.id }}</td> -->
                            <td class="text-center">{{ extra.placa }}</td>
                            <td class="text-center">{{ extra.numeroRCE }}</td>
                            <td class="text-center">{{ extra.empresa?.nombre }}</td>
                            <td class="text-center">{{ extra.intermediariaRCE }}</td>
                            <td class="text-center">{{ extra.fecha_expedicionRCE | date:'dd/MM/yyyy' }}</td>
                            <td class="text-center">{{ extra.fecha_vencimientoRCE | date:'dd/MM/yyyy' }}</td>
                            <td class="text-center">{{ extra.estadoCalculado.diasRestantes }}</td>
                            <td class="text-center">
                              <span [ngClass]="getEstadoColor(extra.estadoCalculado.estado)">
                                {{ extra.estadoCalculado.estado | uppercase }}
                              </span>
                            </td>
                            <td class="text-center align-middle">
                              <div class="action d-flex justify-content-center">
                                <ul class="list-inline d-flex gap-2 m-0">

                                  <!-- Botón Editar (Solo si puede editar) -->
                                  <li class="list-inline-item edit" *ngIf="puedeEditarBimestral(extra)">
                                    <a href="javascript:void(0)">
                                      <i class="icon-pencil-alt"
                                        (click)="openModalExtracontractual(myModal9, extra?.id)"
                                        ngbTooltip="Editar"></i>
                                    </a>
                                  </li>

                                  <!-- Botón Eliminar -->
                                  <li class="list-inline-item delete">
                                    <a href="javascript:void(0)">
                                      <i class="icon-trash" (click)="inactivarPorIdExtracontractual(extra.id)"
                                        ngbTooltip="Inactivar"></i>
                                    </a>
                                  </li>

                                </ul>
                              </div>
                            </td>
                          </tr>

                        </tbody>
                      </table>
                    </div>
                    <div class="d-flex justify-content-between align-items-center mt-4">
                      <!-- Selector de registros por página alineado a la izquierda -->
                      <div class="d-flex align-items-center">
                        <label for="pageSize1" class="me-2">Mostrar:</label>
                        <select id="pageSize1" class="form-select w-auto" [(ngModel)]="pageSize1" (change)="page1 = 1">
                          <option *ngFor="let size1 of [5, 10, 20, 50, 100]" [value]="size1">{{ size1 }}</option>
                        </select>
                        <span class="ms-2">registros por página</span>
                      </div>

                      <!-- Mostrar cantidad total de registros centrado -->
                      <div class="mx-auto text-center">
                        <span class="badge bg-primary ms-1"><b><span>Total Registros: </span>{{
                            historialExtracontractual.length || 0 }}</b></span>
                      </div>


                      <!-- Paginador alineado a la derecha -->
                      <div class="text-end paginador-personalizado">
                        <pagination-controls (pageChange)="page1 = $event" [maxSize]="5" [directionLinks]="true"
                          [autoHide]="true" previousLabel="Anterior" nextLabel="Siguiente">
                        </pagination-controls>
                      </div>
                    </div>
                    <div class="card-body">
                      <div class="btn-showcase text-center">
                        <button class="btn btn-outline-success-2x" type="button" placement="top"
                          ngbTooltip="Exportar a Excel" (click)="
                            exportarExcel(
                              'tblExtraContractual',
                              'Listado_Extracontractual'
                            )
                          ">
                          <i class="icofont icofont-file-excel"></i> EXCEL
                        </button>

                        <button class="btn btn-outline-danger-2x" type="button" placement="top"
                          ngbTooltip="Exportar a PDF" (click)="
                            exportToPDF(
                              'tblExtraContractual',
                              'Listado_Extracontractual',
                              'Listado de Extracontractual'
                            )
                          ">
                          <i class="icofont icofont-file-pdf"></i> PDF
                        </button>

                        <button class="btn btn-outline-primary-2x" type="button" placement="top"
                          ngbTooltip="Renovar Póliza" (click)="openModalExtracontractual(myModal9)">
                          <i class="icofont icofont-refresh"></i> Renovar
                        </button>
                      </div>
                    </div>
                  </div>


                </div>
              </ng-template>
            </li>
            <li [ngbNavItem]="5" class="nav-tabs" *ngIf="validarPTR">
              <a ngbNavLink class="text-primary text-uppercase"><strong>HISTORIAL PÓLIZA TODO RIESGOS</strong></a>
              <ng-template ngbNavContent>
                <div class="card">


                  <div class="card-body custom-datatable noscroll">
                    <div class="custom-datatable table-responsive">
                      <table class="table table-hover table-bordered" id="tblTodoRiesgo">
                        <thead class="bg-primary">
                          <tr>
                            <!--  <th class="text-center" style="cursor: pointer">ID</th> -->
                            <th class="text-center" style="cursor: pointer"><strong>PLACA</strong></th>
                            <th class="text-center" style="cursor: pointer"><strong>NÚMERO</strong></th>
                            <th class="text-center" style="cursor: pointer"><strong>ASEGURADORA</strong></th>
                            <th class="text-center" style="cursor: pointer"><strong>FECHA EXPEDICIÓN</strong></th>
                            <th class="text-center" style="cursor: pointer"><strong>FECHA VENCIMIENTO</strong></th>
                            <th class="text-center" style="cursor: pointer"><strong>DIAS POR VENCER</strong></th>
                            <th class="text-center" style="cursor: pointer"><strong>ESTADO</strong></th>
                            <th class="text-center" style="cursor: pointer"><strong>ACCIONES</strong></th>
                          </tr>
                        </thead>

                        <tbody>
                          <tr
                            *ngFor="let riesgo of historialTodoRiesgo | paginate: { itemsPerPage: pageSize1, currentPage: page1 }">
                            <!--  <td class="text-center">{{ riesgo.id }}</td> -->
                            <td class="text-center">{{ riesgo.placa }}</td>
                            <td class="text-center">{{ riesgo.numeroTD }}</td>
                            <td class="text-center">{{ riesgo.empresa?.nombre }}</td>
                            <td class="text-center">{{ riesgo.fecha_expedicionTD | date:'dd/MM/yyyy' }}</td>
                            <td class="text-center">{{ riesgo.fecha_vencimientoTD | date:'dd/MM/yyyy' }}</td>
                            <td class="text-center">{{ riesgo.estadoCalculado.diasRestantes }}</td>
                            <td class="text-center">
                              <span [ngClass]="getEstadoColor(riesgo.estadoCalculado.estado)">
                                {{ riesgo.estadoCalculado.estado | uppercase }}
                              </span>
                            </td>
                            <td class="text-center align-middle">
                              <div class="action d-flex justify-content-center">
                                <ul class="list-inline d-flex gap-2 m-0">

                                  <!-- Botón Editar (Solo si puede editar) -->
                                  <li class="list-inline-item edit" *ngIf="puedeEditarBimestral(riesgo)">
                                    <a href="javascript:void(0)">
                                      <i class="icon-pencil-alt" (click)="openModalTodoRiesgo(myModal10, riesgo?.id)"
                                        ngbTooltip="Editar"></i>
                                    </a>
                                  </li>

                                  <!-- Botón Eliminar -->
                                  <li class="list-inline-item delete">
                                    <a href="javascript:void(0)">
                                      <i class="icon-trash" (click)="inactivarPorIdTodoRiesgo(riesgo.id)"
                                        ngbTooltip="Inactivar"></i>
                                    </a>
                                  </li>

                                </ul>
                              </div>
                            </td>


                          </tr>

                        </tbody>
                      </table>
                    </div>
                    <div class="d-flex justify-content-between align-items-center mt-4">
                      <!-- Selector de registros por página alineado a la izquierda -->
                      <div class="d-flex align-items-center">
                        <label for="pageSize1" class="me-2">Mostrar:</label>
                        <select id="pageSize1" class="form-select w-auto" [(ngModel)]="pageSize1" (change)="page1 = 1">
                          <option *ngFor="let size1 of [5, 10, 20, 50, 100]" [value]="size1">
                            {{ size1 }}
                          </option>
                        </select>
                        <span class="ms-2">registros por página</span>
                      </div>

                      <!-- Mostrar cantidad total de registros centrado -->
                      <div class="mx-auto text-center">
                        <span class="badge bg-primary ms-1"><b><span>Total Registros: </span>{{
                            historialTodoRiesgo?.length || 0 }}</b></span>
                      </div>

                      <!-- Paginador alineado a la derecha -->
                      <div class="text-end paginador-personalizado">
                        <pagination-controls (pageChange)="page1 = $event" [maxSize]="5" [directionLinks]="true"
                          [autoHide]="true" previousLabel="Anterior" nextLabel="Siguiente">
                        </pagination-controls>
                      </div>
                    </div>
                    <div class="card-body">
                      <div class="btn-showcase text-center">
                        <button class="btn btn-outline-success-2x" type="button" placement="top"
                          ngbTooltip="Exportar a Excel" (click)="
                            exportarExcel(
                              'tblTodoRiesgo',
                              'Listado_Todo_Riesgo'
                            )
                          ">
                          <i class="icofont icofont-file-excel"></i> EXCEL
                        </button>

                        <button class="btn btn-outline-danger-2x" type="button" placement="top"
                          ngbTooltip="Exportar a PDF" (click)="
                            exportToPDF(
                              'tblTodoRiesgo',
                              'Listado_Todo_Riesgo',
                              'Listado de Todo Riesgo'
                            )
                          ">
                          <i class="icofont icofont-file-pdf"></i> PDF
                        </button>

                        <button class="btn btn-outline-primary-2x" type="button" placement="top"
                          ngbTooltip="Renovar Póliza" (click)="openModalTodoRiesgo(myModal10)">
                          <i class="icofont icofont-refresh"></i> Renovar
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-template>
            </li>
          </ul>
          <div [ngbNavOutlet]="nav" class="mt-2"></div>
        </div>
      </ng-template>
    </ngb-panel>

    <ngb-panel id="static-8">
      <ng-template ngbPanelTitle>
        <i class="icofont icofont-safety"></i>
        <span class="ms-2 text-uppercase"><strong>Siniestros Viales:</strong></span>
      </ng-template>
      <ng-template ngbPanelContent>
        <div class="card">
          <div class="card-body custom-datatable noscroll">
            <div class="custom-datatable table-responsive">
              <table class="table table-hover table-bordered" id="tblSiniestros">
                <thead class="bg-primary">
                  <tr>
                    <!--  <th class="text-center" style="cursor: pointer">ID</th> -->
                    <th class="text-center" style="cursor: pointer"><strong>CONSECUTIVO:</strong></th>
                    <th class="text-center" style="cursor: pointer"><strong>PLACA:</strong></th>
                    <th class="text-center" style="cursor: pointer"><strong>FECHA SINIESTRO:</strong></th>
                    <th class="text-center" style="cursor: pointer"><strong>HORA SINIESTRO:</strong></th>
                    <th class="text-center" style="cursor: pointer"><strong>FECHA REPORTE:</strong></th>
                    <th class="text-center" style="cursor: pointer"><strong>HORA REPORTE:</strong></th>
                    <th class="text-center" style="cursor: pointer"><strong>ESTADO:</strong></th>
                    <th class="text-center" style="cursor: pointer"><strong>ACCIONES:</strong></th>
                  </tr>
                </thead>

                <tbody>
                  <tr *ngFor="let siniestro of siniestros | paginate: { itemsPerPage: pageSize1, currentPage: page1 }">
                    <td class="text-center">{{ siniestro.consecutivo }}</td>
                    <td class="text-center">{{ siniestro.placa }}</td>
                    <td class="text-center">{{ siniestro.fecha_siniestro | date:'dd/MM/yyyy' }}</td>
                    <td class="text-center">{{ siniestro.hora_siniestro }}</td>
                    <td class="text-center">{{ siniestro.fecha_reporte | date:'dd/MM/yyyy' }}</td>
                    <td class="text-center">{{ siniestro.hora_reporte }}</td>
                     <td class="text-center">
                <span class="badge" [ngClass]="'bg-' + siniestro.estado_color">
                  {{ siniestro.estado_label }}
                </span>
              </td>
                    <td class="text-center align-middle">
                      <div class="action d-flex justify-content-center">
                        <ul class="list-inline d-flex align-items-center gap-2 mb-0">

                          <!-- Botón Editar (Solo si puede editar) -->
                         <li class="list-inline-item edit" *ngIf="siniestro.estado === 1">
  <a href="javascript:void(0)" (click)="editarSiniestro(siniestro)">
    <i class="icon-pencil-alt" ngbTooltip="Editar"></i>
  </a>
</li>

                          <li class="list-inline-item delete">
                      <a href="javascript:void(0)">
                        <i class="icon-trash text-danger" *ngIf="siniestro.estado === 1"
                          (click)="inactivarSiniestro(siniestro)" ngbTooltip="Inactivar"></i>
                      </a>
                    </li>

                    <li class="list-inline-item edit">
                      <a href="javascript:void(0)">
                        <i class="icon-check text-success" *ngIf="siniestro.estado === 0"
                          (click)="activarSiniestro(siniestro)" ngbTooltip="Activar"></i>
                      </a>
                    </li>

                        </ul>
                      </div>
                    </td>


                  </tr>

                </tbody>
              </table>
            </div>
            <div class="d-flex justify-content-between align-items-center mt-4">
              <!-- Selector de registros por página alineado a la izquierda -->
              <div class="d-flex align-items-center">
                <label for="pageSize1" class="me-2">Mostrar:</label>
                <select id="pageSize1" class="form-select w-auto" [(ngModel)]="pageSize1" (change)="page1 = 1">
                  <option *ngFor="let size1 of [5, 10, 20, 50, 100]" [value]="size1">
                    {{ size1 }}
                  </option>
                </select>
                <span class="ms-2">registros por página</span>
              </div>

              <!-- Mostrar cantidad total de registros centrado -->
              <div class="mx-auto text-center">
                <span class="badge bg-primary ms-1"><b><span>Total Registros: </span>{{ siniestros.length || 0
                    }}</b></span>
              </div>
              <!-- Paginador alineado a la derecha -->
              <div class="text-end paginador-personalizado">
                <pagination-controls (pageChange)="page1 = $event" [maxSize]="5" [directionLinks]="true"
                  [autoHide]="true" previousLabel="Anterior" nextLabel="Siguiente">
                </pagination-controls>
              </div>
            </div>
            <div class="card-body">
              <div class="btn-showcase text-center">
                <button class="btn btn-outline-success-2x" type="button" placement="top" ngbTooltip="Exportar a Excel"
                  (click)="
                    exportarExcel(
                      'tblSiniestros',
                      'Listado_Siniestros'
                    )
                  ">
                  <i class="icofont icofont-file-excel"></i> EXCEL
                </button>

                <button class="btn btn-outline-danger-2x" type="button" placement="top" ngbTooltip="Exportar a PDF"
                  (click)="
                    exportToPDF(
                      'tblSiniestros',
                      'Listado_Siniestros',
                      'Listado de Siniestros'
                    )
                  ">
                  <i class="icofont icofont-file-pdf"></i> PDF
                </button>

                <button class="btn btn-outline-primary-2x" type="button" placement="top" ngbTooltip="Crear Siniestro"
                  (click)="CrearSiniestro()">
                  <i class="icofont icofont-plus"></i> Crear
                </button>
              </div>
            </div>
          </div>
        </div>
      </ng-template>
    </ngb-panel>
  </ngb-accordion>

  <div class="btn-showcase my-4">
    <button type="button" class="btn btn-primary" (click)="Actualizar()">
      Actualizar
    </button>
  </div>
</div>

<ng-template #myModal let-modal>
  <div class="card border-4 rounded-3">
    <div class="card-header bg-primary text-white d-flex justify-content-between align-items-center rounded-top">
      <h5 class="mb-0"><strong>CREACIÓN DE ENTIDADES / EMPRESAS</strong></h5>
    </div>
    <div class="modal-body">
      <form [formGroup]="formEmpresa">
        <!-- Inputs antes de la tabla -->
        <div class="row g-3">
          <div class="col-md-3">
            <label class="form-label" for="nit"><strong>CC / NIT</strong></label>
            <input #inputNit class="form-control" id="nit" type="number" required
              placeholder="Ingrese su número de documento o nit" formControlName="nit"
              [class.is-invalid]="formEmpresa.get('nit')?.invalid && validate" (input)="limitarLongitud($event, 10)" />
            <div *ngIf="formEmpresa.get('nit')?.invalid && validate" class="invalid-feedback">
              Por favor, ingresa un número de documento.
            </div>
          </div>

          <div class="col-md-3">
            <label class="form-label" for="digito"><strong>Dígito de Verificación</strong></label>
            <input class="form-control" id="digito" type="number" placeholder="Ingrese el dígito de verificación"
              required formControlName="digito" [class.is-invalid]="formEmpresa.get('digito')?.invalid && validate" />
            <div *ngIf="formEmpresa.get('digito')?.invalid && validate" class="invalid-feedback">
              Por favor, ingresa un digito de verificación.
            </div>
          </div>

          <div class="col-md-3">
            <label class="form-label" for="nombre"><strong>Nombre Completo/Razon Social</strong></label>
            <input #inputNombre class="form-control" id="nombre" type="text"
              placeholder="Ingrese el nombre o razon social" required formControlName="nombre" [class.is-invalid]="
                formEmpresa.get('nombre')?.invalid && validate
              " />
            <div *ngIf="formEmpresa.get('nombre')?.invalid && validate" class="invalid-feedback">
              Por favor, ingresa un nombre o razón social.
            </div>
          </div>
          <div class="col-md-3">
            <label class="form-label" for="direccion"><strong>Dirección</strong></label>
            <input class="form-control" id="direccion" type="text" placeholder="Ingresa una dirección" required
              formControlName="direccion" [class.is-invalid]="formEmpresa.get('direccion')?.invalid && validate" />
            <div *ngIf="formEmpresa.get('direccion')?.invalid && validate" class="invalid-feedback">
              Por favor, ingresa una dirección.
            </div>
          </div>
          <div class="col-md-3">
            <label class="form-label" for="ciudad"><strong>Ciudad</strong></label>
            <ng-select #inputCiudad id="ciudad" [items]="municipios" bindLabel="MUNICIPIO" bindValue="IDMUN"
              placeholder="Selecciona una ciudad" class="js-example-placeholder-multiple" name="lugarex" required
              formControlName="ciudad" [class.is-invalid]="formEmpresa.get('ciudad')?.invalid && validate">
            </ng-select>
            <div *ngIf="formEmpresa.get('ciudad')?.invalid && validate" class="invalid-feedback">
              Por favor, ingresa una ciudad.
            </div>
          </div>
          <div class="col-md-3">
            <label class="form-label" for="telefono"><strong>Teléfono fijo</strong></label>
            <input class="form-control" id="telefono" type="number" required placeholder="Ingresa el teléfono fijo"
              formControlName="telefono" (input)="limitarLongitud($event, 10)" />
          </div>
          <div class="col-md-3">
            <label class="form-label" for="celular"><strong>Teléfono celular</strong></label>
            <input class="form-control" id="celular" type="number" required placeholder="Ingresa el teléfono celular"
              formControlName="celular" (input)="limitarLongitud($event, 10)"
              [class.is-invalid]="formEmpresa.get('celular')?.invalid && validate" />
            <div *ngIf="formEmpresa.get('celular')?.invalid && validate" class="invalid-feedback">
              Por favor, ingresa un número de celular.
            </div>
          </div>
          <div class="col-md-3">
            <label class="form-label" for="email"><strong>Correo electrónico</strong></label>
            <input class="form-control" id="email" type="text" placeholder="Ingresa un correo valido"
              formControlName="email" required [class.is-invalid]="formEmpresa.get('email')?.invalid && validate" />
            <div *ngIf="formEmpresa.get('email')?.invalid && validate" class="invalid-feedback">
              Por favor, ingresa un correo electronico.
            </div>
          </div>
          <div class="row g-3 mb-3">
            <div class="mb-3">
              <label><strong>Observaciones</strong></label>
              <textarea class="form-control" id="observaciones" rows="3" formControlName="observaciones"></textarea>
            </div>
          </div>
        </div>

        <div class="card-header bg-primary text-white d-flex justify-content-between align-items-center rounded-top">
          <h5 class="mb-0"><strong>TIPO DE EMPRESA / ENTIDAD</strong></h5>
        </div>
        <!-- Tabla con exámenes -->
        <div class="row">
          <div class="col-md-4 my-4">
            <label class="d-block" for="chk-ani1">
              <input class="checkbox_animated me-2" id="chk-ani1" type="checkbox" formControlName="eps" />
              <strong>EPS (SALUD)</strong>
            </label>
            <label class="d-block" for="chk-ani2">
              <input class="checkbox_animated me-2" id="chk-ani2" type="checkbox" formControlName="arl" />
              <strong>ARL (RIEGOS LABORALES)</strong>
            </label>
            <label class="d-block" for="chk-ani3">
              <input class="checkbox_animated me-2" id="chk-ani3" type="checkbox" formControlName="afp" />
              <strong>AFP (FONDO DE PENSIONES)</strong>
            </label>
            <label class="d-block" for="chk-ani4">
              <input class="checkbox_animated me-2" id="chk-ani4" type="checkbox" formControlName="ces" />
              <strong>CES (CESANTIAS)</strong>
            </label>
            <label class="d-block" for="chk-ani5">
              <input class="checkbox_animated me-2" id="chk-ani5" type="checkbox" formControlName="ccf" />
              <strong>CCF (CAJA DE COMPESANCIÓN FAMILIAR)</strong>
            </label>
            <label class="d-block" for="chk-ani6">
              <input class="checkbox_animated me-2" id="chk-ani6" type="checkbox" formControlName="bancos" />
              <strong>BANCOS</strong>
            </label>
          </div>
          <div class="col-md-4 my-4">
            <label class="d-block" for="chk-ani7">
              <input class="checkbox_animated me-2" id="chk-ani7" type="checkbox" formControlName="transporte" />
              <strong>EMPRESA DE TRANSPORTES
              DE TRANSPORTES</strong>
            </label>
            <label class="d-block" for="chk-ani8">
              <input class="checkbox_animated me-2" id="chk-ani8" type="checkbox" formControlName="colegio" />
              <strong>COLEGIO</strong>
            </label>
            <label class="d-block" for="chk-ani9">
              <input class="checkbox_animated me-2" id="chk-ani9" type="checkbox" formControlName="cda" />
              <strong>CDA</strong>
            </label>
            <label class="d-block" for="chk-ani10">
              <input class="checkbox_animated me-2" id="chk-ani10" type="checkbox" formControlName="taller" />
              <strong>TALLER MECÁNICO</strong>
            </label>
            <label class="d-block" for="chk-ani11">
              <input class="checkbox_animated me-2" id="chk-ani11" type="checkbox" formControlName="eds" />
              <strong>EDS</strong>
            </label>
            <label class="d-block" for="chk-ani12">
              <input class="checkbox_animated me-2" id="chk-ani12" type="checkbox" formControlName="contratista" />
              <strong>CLIENTES/CONTRATANTES</strong>
            </label>
          </div>
          <div class="col-md-4 my-4">
            <label class="d-block" for="chk-ani13">
              <input class="checkbox_animated me-2" id="chk-ani13" type="checkbox" formControlName="proveedor" />
              <strong>PROVEEDOR</strong>
            </label>
            <label class="d-block" for="chk-ani14">
              <input class="checkbox_animated me-2" id="chk-ani14" type="checkbox" formControlName="aseguradora" />
              <strong>ASEGURADORA</strong>
            </label>
            <label class="d-block" for="chk-ani16">
              <input class="checkbox_animated me-2" id="chk-ani16" type="checkbox" formControlName="almacen" />
              <strong>ALMACÉN DE REPUESTO</strong>
            </label>
            <label class="d-block" for="chk-ani17">
              <input class="checkbox_animated me-2" id="chk-ani17" type="checkbox" formControlName="serviteca" />
              <strong>SERVITECAS</strong>
            </label>
          </div>
        </div>
      </form>
    </div>

    <div class="modal-footer">
      <button class="btn btn-primary" (click)="guardarEmpresa(modalEmpresaRef)">
        Guardar
      </button>
      <button class="btn btn-secondary" (click)="modal.dismiss()">
        Cancelar
      </button>
    </div>
  </div>
</ng-template>

<ng-template #myModal2 let-modal>
  <div class="card border-4 rounded-3">
    <div class="card-header bg-primary text-white d-flex justify-content-between align-items-center rounded-top">
      <h5 class="mb-0"><strong>CREACIÓN DE CLASE DE VEHICULO</strong></h5>
    </div>
    <div class="modal-body">
      <form [formGroup]="formClase">
        <!-- Inputs antes de la tabla -->
        <div class="row g-3">
          <div class="col-md-3">
            <label class="form-label" for="tipos"><strong>Clase</strong></label>
            <input class="form-control" id="tipos" type="text" placeholder="Ingrese la clase" formControlName="tipos" />
          </div>
        </div>
      </form>
    </div>

    <div class="modal-footer">
      <button class="btn btn-primary" (click)="guardarClase()">Guardar</button>
      <button class="btn btn-secondary" (click)="modal.dismiss()">
        Cancelar
      </button>
    </div>
  </div>
</ng-template>

<ng-template #myModal3 let-modal>
  <div class="card border-4 rounded-3">
    <div class="card-header bg-primary text-white d-flex justify-content-between align-items-center rounded-top">
      <h5 class="mb-0 text-dark">
        {{ editMode ? 'EDITAR TARJETA OPERACIÓN - ID: ' + formTarjeta.get('id')?.value : 'CREACIÓN DE TARJETA OPERACIÓN'
        }}
      </h5>
    </div>
    <div class="modal-body">
      <form [formGroup]="formTarjeta">
        <div class="row g-3 mb-3">
          <div class="col-md-3">
            <label class="form-label" for="numero_tarjeta"> <strong>Número</strong></label>
            <input #inputTarjeta class="form-control" id="numero_tarjeta" type="number" placeholder="Ingrese el número"
              formControlName="numero_tarjeta" autocomplete="off" />
          </div>
          <div class="col-md-3">
            <label class="form-label" for="fecha_expedicion"> <strong>Expedición</strong></label>
            <div class="input-group input-group-sm">
              <input #inputFechaExpedicionTarjeta id="fecha_expedicion" type="date"
                class="form-control form-control-lg fs-14" name="fecha_expedicion" placeholder="Last name"
                [max]="maxDate" formControlName="fecha_expedicion" />
            </div>
          </div>
          <div class="col-md-3">
            <label class="form-label" for="fecha_vencimiento"><strong>Vencimiento</strong></label>
            <div class="input-group input-group-sm">
              <input #inputFechaVencimientoTarjeta id="fecha_vencimiento" type="date"
                class="form-control form-control-lg fs-14" name="fecha_vencimiento" placeholder="Last name"
                [min]="minDate" formControlName="fecha_vencimiento" />
            </div>
          </div>
        </div>
      </form>
    </div>

    <div class="modal-footer">
      <button class="btn btn-primary" (click)="guardarTarjetaOperacion()">
        {{ editMode ? "Actualizar" : "Guardar" }}
      </button>
      <button class="btn btn-secondary" (click)="modal.dismiss()">
        Cancelar
      </button>
    </div>
  </div>
</ng-template>

<ng-template #myModal4 let-modal>
  <div class="card border-4 rounded-3">
    <div class="card-header bg-primary text-white d-flex justify-content-between align-items-center rounded-top">
      <h5 class="mb-0">
        {{ editMode ? 'EDITAR SOAT - ID: ' + formSoat.get('id')?.value : 'CREACIÓN DE SOAT' }}
      </h5>
    </div>
    <div class="modal-body">
      <form [formGroup]="formSoat">
        <div class="row g-3 mb-3">
          <div class="col-md-3">
            <label class="form-label" for="aseguradora"><strong>Aseguradora</strong></label>
            <ng-select #inputAseguradoraSoat [items]="empresasaseguradora" bindLabel="nombre" bindValue="nit"
              placeholder="Selecciona una opción" class="js-example-placeholder-multiple" style="flex-grow: 1"
              formControlName="aseguradora">
            </ng-select>
          </div>

          <div class="col-md-3">
            <label class="form-label" for="numero_tarjeta">
              <strong>Número</strong></label>
            <input #inputNumeroSoat class="form-control" id="numero_tarjeta" type="number"
              placeholder="Ingrese el número" formControlName="id_soat" autocomplete="off" />
          </div>
          <div class="col-md-3">
            <label class="form-label" for="fecha_soat"><strong>Fecha expedición</strong></label>
            <div class="input-group input-group-sm">
              <input #inputFechaExpedicionSoat id="fecha_soat" type="date" class="form-control form-control-lg fs-14"
                name="fecha_soat" [max]="maxDate" formControlName="fecha_soat" />
            </div>
          </div>
          <div class="col-md-3">
            <label class="form-label" for="vencimiento_soat"><strong>Fecha vencimiento</strong></label>
            <div class="input-group input-group-sm">
              <input #inputFechaVencimientoSoat id="vencimiento_soat" type="date"
                class="form-control form-control-lg fs-14" name="vencimiento_soat" [min]="minDate"
                formControlName="vencimiento_soat" />
            </div>
          </div>
        </div>

        <div class="row g-3 mb-3">
          <div class="col-md-3">
            <label class="form-label" for="valor">
              <strong>Valor</strong></label>
            <input #inputValorSoat class="form-control" id="valor" type="number" placeholder="Ingrese el número"
              formControlName="valor" />
          </div>
          <div class="col-md-3">
            <label class="form-label" for="tarifa">
              <strong>Tarifa</strong></label>
            <input #inputTarifaSoat class="form-control" id="tarifa" type="number" placeholder="Ingrese el número"
              formControlName="tarifa" />
          </div>
        </div>
      </form>
    </div>

    <div class="modal-footer">
      <button class="btn btn-primary" (click)="guardarSoat()">
        {{ editMode ? "Actualizar" : "Guardar" }}
      </button>
      <button class="btn btn-secondary" (click)="modal.dismiss()">
        Cancelar
      </button>
    </div>
  </div>
</ng-template>

<ng-template #myModal5 let-modal>
  <div class="card border-4 rounded-3">
    <div class="card-header bg-primary text-white d-flex justify-content-between align-items-center rounded-top">
      <h5 class="mb-0">
        {{ editMode ? 'EDITAR CDA - ID: ' + formCda.get('id')?.value : 'CREACIÓN DE CDA' }}
      </h5>
    </div>
    <div class="modal-body">
      <form [formGroup]="formCda">
        <div class="row g-3 mb-3">
          <div class="col-md-3">
            <label class="form-label" for="idcda">
              <strong>Certificado</strong></label>
            <input #inputCertificadoSoat class="form-control" id="idcda" type="text"
              placeholder="Ingrese el certificado" formControlName="idcda" />
          </div>
          <div class="col-md-3">
            <label class="form-label" for="centrocda"><strong>Centro CDA</strong></label>
            <ng-select #inputCentroCda [items]="empresascda" bindLabel="nombre" bindValue="nit"
              placeholder="Selecciona una opción" class="js-example-placeholder-multiple" style="flex-grow: 1"
              formControlName="centrocda">
            </ng-select>
          </div>
          <div class="col-md-3">
            <label class="form-label" for="fechacda">
              <strong>Fecha de expedición</strong></label>
            <div class="input-group input-group-sm">
              <input #inputFechaExpedicionCda id="fechacda" type="date" class="form-control form-control-lg fs-14"
                name="fechacda" [max]="maxDate" formControlName="fechacda" />
            </div>
          </div>
          <div class="col-md-3">
            <label class="form-label" for="vcda">
              <strong>Fecha de vencimiento</strong></label>
            <div class="input-group input-group-sm">
              <input #inputFechaVencimientoCda id="vcda" type="date" class="form-control form-control-lg fs-14"
                name="vcda" [min]="minDate" formControlName="vcda" />
            </div>
          </div>
        </div>

        <br />
      </form>
    </div>

    <div class="modal-footer">
      <button class="btn btn-primary" (click)="guardarCda()">
        {{ editMode ? "Actualizar" : "Guardar" }}
      </button>

      <button class="btn btn-secondary" (click)="modal.dismiss()">
        Cancelar
      </button>
    </div>
  </div>
</ng-template>

<ng-template #myModal6 let-modal>
  <div class="card border-4 rounded-3">
    <div class="card-header bg-primary text-white d-flex justify-content-between align-items-center rounded-top">
      <h5 class="mb-0">
        {{ editMode ? 'EDITAR EXTINTOR - ID: ' + formExtintor.get('id')?.value : 'CREACIÓN DE EXTINTOR' }}
      </h5>
    </div>
    <div class="modal-body">
      <form [formGroup]="formExtintor">
        <div class="row g-3 mb-3">
          <div class="col-md-4">
            <label class="form-label" for="idextintor">
              <strong>ID Extintor *:</strong></label>
            <input #idextintor class="form-control" id="idextintor" type="text" placeholder="Ingrese el id del extintor"
              formControlName="idextintor" autocomplete="off" />
          </div>
          <div class="col-md-4">
            <label class="form-label" for="frecarga">
              <strong>Recarga de extintor *:</strong></label>
            <div class="input-group input-group-sm">
              <input #inputFreCargaExtintor id="frecarga" type="date" class="form-control form-control-lg fs-14"
                name="frecarga" [max]="maxDate" formControlName="frecarga" />
            </div>
          </div>
          <div class="col-md-4">
            <label class="form-label" for="vrecarga">
              <strong>Vencimiento *:</strong></label>
            <div class="input-group input-group-sm">
              <input #inputVencimientoExtintor id="vrecarga" type="date" class="form-control form-control-lg fs-14"
                name="vrecarga" [min]="minDate" formControlName="vrecarga" />
            </div>
          </div>
        </div>

        <br />
      </form>
    </div>

    <div class="modal-footer">
      <button class="btn btn-primary" (click)="guardarExtintor()">
        {{ editMode ? "Actualizar" : "Guardar" }}
      </button>

      <button class="btn btn-secondary" (click)="modal.dismiss()">
        Cancelar
      </button>
    </div>
  </div>
</ng-template>

<ng-template #myModal7 let-modal>
  <div class="card border-4 rounded-3">
    <div class="card-header bg-primary text-white d-flex justify-content-between align-items-center rounded-top">
      <h5 class="mb-0">
        {{ editMode ? 'EDITAR BIMESTRAL - ID: ' + formBimestral.get('id')?.value : 'CREACIÓN DE BIMESTRAL' }}
      </h5>
    </div>
    <div class="modal-body">
      <form [formGroup]="formBimestral">
        <div class="row g-3 mb-3">
          <div class="col-md-3">
            <label class="form-label" for="centro_diagnostico"><strong>Centro RTM: *</strong></label>
            <ng-select #inputCentroDiagnosticoBim [items]="empresascda" bindLabel="nombre" bindValue="nit"
              placeholder="Selecciona una opción" class="js-example-placeholder-multiple" style="flex-grow: 1"
              formControlName="centro_diagnostico">
            </ng-select>
          </div>
          <div class="col-md-3">
            <label class="form-label" for="revision_aprobada"><strong>Revisión Aprobada: *</strong></label>
            <ng-select #inputRevisionBim [items]="Revision" bindLabel="label" bindValue="value"
              placeholder="Seleciona una opción" class="js-example-placeholder-multiple"
              formControlName="revision_aprobada">
            </ng-select>
            <div class="valid-feedback">Looks good!</div>
          </div>
          <div class="col-md-3">
            <label class="form-label" for="ultima_revision"><strong>Última Revisión: *</strong></label>
            <div class="input-group input-group-sm">
              <input #inputUltimaRevisionBim id="ultima_revision" type="date" class="form-control form-control-lg fs-14"
                name="ultima_revision" [max]="maxDate" formControlName="ultima_revision" />
            </div>
            <div class="valid-feedback">Looks good!</div>
          </div>
          <div class="col-md-3">
            <label class="form-label" for="proxima_revision"><strong>Próxima Revisión: *</strong></label>
            <div class="input-group input-group-sm">
              <input #inputProximaRevisionBim id="proxima_revision" type="date"
                class="form-control form-control-lg fs-14" name="proxima_revision" [min]="minDate"
                formControlName="proxima_revision" />
            </div>
            <div class="valid-feedback">Looks good!</div>
          </div>
        </div>
      </form>
    </div>

    <div class="modal-footer">
      <button class="btn btn-primary" (click)="guardarBimestral()">
        {{ editMode ? "Actualizar" : "Guardar" }}
      </button>

      <button class="btn btn-secondary" (click)="modal.dismiss()">
        Cancelar
      </button>
    </div>
  </div>
</ng-template>

<ng-template #myModal8 let-modal>
  <div class="card border-4 rounded-3">
    <div class="card-header bg-primary text-white d-flex justify-content-between align-items-center rounded-top">
      <h5 class="mb-0">
        {{ editMode ? 'EDITAR CONTRACTUAL - ID: ' + formContractual.get('id')?.value : 'CREACIÓN DE CONTRACTUAL' }}
      </h5>
    </div>
    <div class="modal-body">
      <form [formGroup]="formContractual">
        <div class="row g-3 mb-3">
          <div class="col-md-3">
            <label class="form-label" for="aseguradora"><strong>Aseguradora</strong></label>
            <ng-select #inputAseguradoraCont [items]="empresasaseguradora" bindLabel="nombre" bindValue="nit"
              placeholder="Selecciona una opción" class="js-example-placeholder-multiple" style="flex-grow: 1"
              formControlName="aseguradoraRCC">
            </ng-select>
          </div>
          <div class="col-md-3">
            <label class="form-label" for="intermediaria">
              <strong>Intermediaria</strong></label>
            <input #inputIntermediaCont class="form-control" id="intermediaria" type="text"
              placeholder="Ingrese el intermediario" formControlName="intermediariaRCC" autocomplete="off" />
          </div>
          <div class="col-md-2">
            <label class="form-label" for="fecha_expedicion">
              <strong>Fecha de expedición</strong></label>
            <div class="input-group input-group-sm">
              <input #inputFechaExpedicionCont id="fecha_expedicion" type="date"
                class="form-control form-control-lg fs-14" name="fecha_expedicion" [max]="maxDate"
                formControlName="fecha_expedicionRCC" />
            </div>
          </div>
          <div class="col-md-2">
            <label class="form-label" for="fecha_vencimiento">
              <strong>Fecha de vencimiento</strong></label>
            <div class="input-group input-group-sm">
              <input #inputFechaVencimientoCont id="fecha_vencimiento" type="date"
                class="form-control form-control-lg fs-14" name="fecha_vencimiento" [min]="minDate"
                formControlName="fecha_vencimientoRCC" />
            </div>
          </div>
          <div class="col-md-2">
            <label class="form-label" for="numero">
              <strong>Número</strong></label>
            <input #inputNumeroCont class="form-control" id="numero" type="text" placeholder="Ingrese el numero"
              formControlName="numeroRCC" autocomplete="off" />
            <div class="valid-feedback">Looks good!</div>
          </div>
        </div>

        <br />
      </form>
    </div>

    <div class="modal-footer">
      <button class="btn btn-primary" (click)="guardarContractual()">
        {{ editMode ? "Actualizar" : "Guardar" }}
      </button>

      <button class="btn btn-secondary" (click)="modal.dismiss()">
        Cancelar
      </button>
    </div>
  </div>
</ng-template>

<ng-template #myModal9 let-modal>
  <div class="card border-4 rounded-3">
    <div class="card-header bg-primary text-white d-flex justify-content-between align-items-center rounded-top">
      <h5 class="mb-0">
        {{ editMode ? 'EDITAR EXTRACONTRACTUAL - ID: ' + formExtracontractual.get('id')?.value : 'CREACIÓN DE
        EXTRACONTRACTUAL' }}
      </h5>
    </div>

    <div class="modal-body">
      <form [formGroup]="formExtracontractual">
        <div class="row g-3 mb-3">
          <div class="col-md-3">
            <label class="form-label campos-flex" for="aseguradora"><strong>Aseguradora</strong></label>
            <ng-select #inputAseguradoraExt [items]="empresasaseguradora" bindLabel="nombre" bindValue="nit"
              placeholder="Selecciona una opción" class="js-example-placeholder-multiple" style="flex-grow: 1"
              formControlName="aseguradoraRCE">
            </ng-select>
          </div>
          <div class="col-md-3">
            <label class="form-label" for="intermediaria">
              <strong>Intermediaria</strong></label>
            <input #inputIntermediaExt class="form-control" id="intermediaria" type="text"
              placeholder="Ingrese el intermediario" formControlName="intermediariaRCE" autocomplete="off" />
          </div>
          <div class="col-md-2">
            <label class="form-label" for="fecha_expedicion">
              <strong>Fecha de expedición</strong></label>
            <div class="input-group input-group-sm">
              <input #inputFechaExpedicionExt id="fecha_expedicion" type="date"
                class="form-control form-control-lg fs-14" name="fecha_expedicion" [max]="maxDate"
                formControlName="fecha_expedicionRCE" />
            </div>
          </div>
          <div class="col-md-2">
            <label class="form-label" for="fecha_vencimiento">
              <strong>Fecha de vencimiento</strong></label>
            <div class="input-group input-group-sm">
              <input #inputFechaVencimientoExt id="fecha_vencimiento" type="date"
                class="form-control form-control-lg fs-14" name="fecha_vencimiento" [min]="minDate"
                formControlName="fecha_vencimientoRCE" />
            </div>
          </div>
          <div class="col-md-2">
            <label class="form-label" for="numero">
              <strong>Número</strong></label>
            <input #inputNumeroExt class="form-control" id="numero" type="text" placeholder="Ingrese el numero"
              formControlName="numeroRCE" autocomplete="off" />
          </div>
        </div>

        <br />
      </form>
    </div>

    <div class="modal-footer">
      <button class="btn btn-primary" (click)="guardarExtracontractual()">
        {{ editMode ? "Actualizar" : "Guardar" }}
      </button>

      <button class="btn btn-secondary" (click)="modal.dismiss()">
        Cancelar
      </button>
    </div>
  </div>
</ng-template>

<ng-template #myModal10 let-modal>
  <div class="card border-4 rounded-3">
    <div class="card-header bg-primary text-white d-flex justify-content-between align-items-center rounded-top">
      <h5 class="mb-0">
        {{ editMode ? 'EDITAR TODO RIESGO - ID: ' + formTodoriesgo.get('id')?.value : 'CREACIÓN DE TODO RIESGO' }}
      </h5>
    </div>

    <div class="modal-body">
      <form [formGroup]="formTodoriesgo">
        <div class="row g-3 mb-3">
          <div class="col-md-3">
            <label class="form-label" for="aseguradora"><strong>Aseguradora</strong></label>
            <ng-select #inputAseguradoraTd [items]="empresasaseguradora" bindLabel="nombre" bindValue="nit"
              placeholder="Selecciona una opción" class="js-example-placeholder-multiple" style="flex-grow: 1"
              formControlName="aseguradoraTD">
            </ng-select>
          </div>
          <div class="col-md-2">
            <label class="form-label" for="fecha_expedicionTD">
              <strong>Fecha de expedición</strong></label>
            <div class="input-group input-group-sm">
              <input #inputFechaExpedicionTd id="fecha_expedicionTD" type="date"
                class="form-control form-control-lg fs-14" name="fecha_expedicionTD" [max]="maxDate"
                formControlName="fecha_expedicionTD" />
            </div>
          </div>
          <div class="col-md-2">
            <label class="form-label" for="fecha_vencimientoTD">
              <strong>Fecha de vencimiento</strong></label>
            <div class="input-group input-group-sm">
              <input #fecha_vencimiento id="fecha_vencimientoTD" type="date" class="form-control form-control-lg fs-14"
                name="fecha_vencimientoTD" [min]="minDate" formControlName="fecha_vencimientoTD" />
            </div>
          </div>
          <div class="col-md-2">
            <label class="form-label" for="numero">
              <strong>Número</strong></label>
            <input #numero class="form-control" id="numero" type="text" placeholder="Ingrese el numero"
              formControlName="numeroTD" autocomplete="off" />
          </div>
        </div>

        <br />
      </form>
    </div>

    <div class="modal-footer">
      <button class="btn btn-primary" (click)="guardarTodoRiesgo()">
        {{ editMode ? "Actualizar" : "Guardar" }}
      </button>

      <button class="btn btn-secondary" (click)="modal.dismiss()">
        Cancelar
      </button>
    </div>
  </div>
</ng-template>